import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Sayfa değiştiğinde yukarı scroll yap
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Anında yukarı git (smooth yerine)
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
